import React, {Component} from "react";
import {Col, Container, Row} from "react-bootstrap";
import Desplegable from "../../desplegable";
import FormInformatica from "../formularios/form_informatica";
import $ from "jquery";

export default class VistaInformatica extends Component {
  constructor(props) {
    super(props);
    this.mostrarInformatica = this.mostrarInformatica.bind(this);
    this.deleteInformatica = this.deleteInformatica.bind(this);
  }

  //DELETE
  //Implementado en la vista borra aquellos desplegables de desplegables
  deleteInformatica(id) {
    let $this = $(this);
    let settings = {
      url: process.env.REACT_APP_API_URL + "/usuarios/" + $this[0].props.DatosUsuario.id + "/informatica/" + $this[0].props.DatosUsuario.datosInformatica[id].id,
      method: "DELETE",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    $.ajax(settings)
      .done(function (response) {
        $this[0].props.setAlert("", "Se ha eliminado correctamente", "success");
        $this[0].props.deleteInformatica(id);
      })
      .fail($this[0].props.ErrorHandling);
  }

  mostrarInformatica() {
    let longitud = 0;
    let Informatica = null;
    let ArrayInformatica = [];

    if (this.props.DatosUsuario.datosInformatica) {
      longitud = this.props.DatosUsuario.datosInformatica.length;
    }
    for (let i = 0; i < longitud; i++) {
      Informatica = (
        <Container>
          <Row>
            <Col lg="6" className="border">
              <h6>Nombre del Programa/Lenguaje de Programación</h6>
              <p>{this.props.DatosUsuario.datosInformatica[i].programName}</p>
            </Col>

            <Col lg="6" className="border">
              <h6>Nivel</h6>
              <p>{this.props.DatosUsuario.datosInformatica[i].level}</p>
            </Col>
          </Row>
        </Container>
      );
      ArrayInformatica.push(
        <Desplegable
          handleButtonShow={this.props.handleButtonShow}
          showModal={this.props.showModalInformaticaArray[i]}
          Toogle={"Conocimiento informático en " + this.props.DatosUsuario.datosInformatica[i].programName}
          id={i}
          key={this.props.DatosUsuario.datosInformatica[i].id}
          value={"4"}
          Text={Informatica}
          deleteFunction={this.deleteInformatica}
          Form={
            <FormInformatica
                DatosUsuario={this.props.DatosUsuario}
                setInformatica={this.props.setInformatica}
                putInformatica={this.props.putInformatica}
                handleButtonShow={this.props.handleButtonShow}
                id={i}
                setAlert={this.props.setAlert}
            />
          }
          canEdit={true}
        />
      );
    }
    if (longitud === 0)
      ArrayInformatica.push(
        <p className="ml-3" key={1}>
          No hay datos actualmente
        </p>
      );
    return ArrayInformatica;
  }

  render() {
    return <React.Fragment>{this.mostrarInformatica()}</React.Fragment>;
  }
}
